import { Text } from '@sendoutcards/quantum-design-ui'
import React from 'react'

const NotFound: React.FC = () => {
  return <Text type="body">No Gifts Found</Text>
}

export default NotFound
